import { type Reply, createReplyData } from 'models';
import { type UseQueryOptions, useQuery } from 'query';
import type { ApiClientResponseError, ResponseErrorDataObject } from 'common/services';
import { getComments } from '../../services';
import { getContentObjectRepliesQueryKey } from '../keys';

export type GetContentObjectRepliesQuery = Reply[];

type P = {
  id: string;
  options?: Partial<UseQueryOptions<Reply[], ApiClientResponseError<ResponseErrorDataObject>>>;
};

export const useContentObjectRepliesQuery = ({ id, options }: P) =>
  useQuery<GetContentObjectRepliesQuery>({
    async queryFn() {
      const { data } = await getComments({ routeParams: { id } });

      return data.map((reply) => createReplyData(reply));
    },
    queryKey: getContentObjectRepliesQueryKey({ id }),
    ...options,
  });
